/* import __COLOCATED_TEMPLATE__ from './geojson-layer.hbs'; */
var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import BaseLayer from './base-layer';
import PopupLayer from './popup-layer';
import TooltipLayer from './tooltip-layer';

/**
 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to render GeoJSON
 * data and display it on the map.
 *
 * @class GeojsonLayer
 * @extends BaseLayer
 */
let GeojsonLayer = (_class = class GeojsonLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "leafletRequiredOptions", [...this.leafletRequiredOptions,
    /**
     * An object in GeoJSON format to display on the map.
     *
     * @argument geoJSON
     * @type {Object}
     */
    'geoJSON']);
    _defineProperty(this, "leafletOptions", [...this.leafletOptions,
    /**
     * A Function defining how GeoJSON points spawn Leaflet layers. It is internally called when data is added,
     * passing the GeoJSON point feature and its LatLng.
     *
     * @argument pointToLayer
     * @type {Function}
     */
    'pointToLayer',
    /**
     * A Function defining the Path options for styling GeoJSON lines and polygons, called internally when data is added.
     *
     * @argument style
     * @type {Function}
     */
    'style',
    /**
     * A Function that will be called once for each created Feature, after it has been created and styled. Useful
     * for attaching events and popups to features.
     *
     * @argument onEachFeature
     * @type {Function}
     */
    'onEachFeature',
    /**
     * A Function that will be used to decide whether to include a feature or not.
     *
     * @argument filter
     * @type {Function}
     */
    'filter',
    /**
     * A Function that will be used for converting GeoJSON coordinates to LatLngs.
     * The default is the coordsToLatLng static method.
     *
     * @argument coordsToLatLng
     * @type {Function}
     */
    'coordsToLatLng',
    /**
     * Whether default Markers for `Point` type Features inherit from group options.
     * Defaults to `false`.
     *
     * @argument markersInheritOptions
     * @type {Boolean}
     */
    'markersInheritOptions']);
    _defineProperty(this, "leafletEvents", [...this.leafletEvents,
    /**
     * Fired when a layer is added to this FeatureGroup.
     *
     * @argument onLayeradd
     * @type {Function}
     */
    'layeradd',
    /**
     * Fired when a layer is removed from this FeatureGroup.
     *
     * @argument onLayerremove
     * @type {Function}
     */
    'layerremove']);
    _defineProperty(this, "leafletDescriptors", [...this.leafletDescriptors, 'style']);
    _defineProperty(this, "componentsToYield", [...this.componentsToYield, {
      name: 'popup-layer',
      as: 'popup',
      component: PopupLayer
    }, {
      name: 'tooltip-layer',
      as: 'tooltip',
      component: TooltipLayer
    }]);
  }
  didChangeGeojson(geoJSON) {
    if (geoJSON) {
      this.pushDataToLeaflet(geoJSON);
    }
  }
  pushDataToLeaflet(geoJSON) {
    if (!this._layer) {
      return;
    }

    // recall that GeoJSON layers are actually layer groups -- we have to clear
    // their contents first...
    this._layer.clearLayers();

    // we need to update the group layers options before re-adding geojson
    // otherwise, they wouldn't get the changes that could be happening meanwhile
    this._layer.options = this.options;
    if (geoJSON) {
      // ...then add new data to recreate the child layers in an updated form
      this._layer.addData(geoJSON);
    }
  }
  createLayer() {
    return this.L.geoJson(...this.requiredOptions, this.options);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "didChangeGeojson", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didChangeGeojson"), _class.prototype)), _class);
export { GeojsonLayer as default };